import { Injectable, Output, EventEmitter } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class LoaderService {

  @Output() LoaderEmitter = new EventEmitter<boolean>();

  constructor() { }
  isLoading = new Subject<boolean>();
  show() { 
    this.isLoading.next(true);
  }
  hide() {
    this.isLoading.next(false);
  }

}
